import type { PropsWithChildren } from "react";
import { createContext } from "react";
import type { ObjectCardActionChecks } from "./useObjectCardChecks";
import type { ObjectDuplicates } from "./useObjectDuplicates";

interface ObjectCardDuplicates extends ObjectDuplicates {
  objectType: string;
  objectId: string;
}

interface ContextValue {
  actionChecks?: ObjectCardActionChecks;
  duplicates?: ObjectCardDuplicates;
}

const ObjectCardChecksContext = createContext<ContextValue | undefined>(undefined);

export const ObjectCardChecksContextProvider = ({
  actionChecks,
  duplicates,
  children,
}: PropsWithChildren<ContextValue>) => (
  <ObjectCardChecksContext value={{ actionChecks, duplicates }}>{children}</ObjectCardChecksContext>
);

export default ObjectCardChecksContext;
